const TableForPolicy = () => {
  return (
    <div className="container p-2 mx-auto sm:p-4 dark:text-gray-800">
      <div className="flex flex-col overflow-x-auto text-xs">
        <div className="flex border-b border-opacity-20 dark:border-gray-300 dark:bg-gray-50">
          <div className="w-32 px-2 py-3 sm:p-3">
            <p className="text-lg">Données</p>
          </div>
          <div className="flex-1 block px-2 py-3  sm:p-3 sm:w-auto text-sm">
            collectivement toutes les informations que vous soumettez à
            Vivalimda Ltd. via le site Web. Cette définition intègre, le cas
            échéant, les définitions fournies dans les Lois sur la protection
            des données;
          </div>
        </div>
        <div className="flex border-b border-opacity-20 dark:border-gray-300 dark:bg-gray-50">
          <div className="w-32 px-2 py-3 sm:p-3">
            <p className="text-lg">Cookies</p>
          </div>
          <div className="flex-1 block px-2 py-3  sm:p-3 sm:w-auto text-sm">
            un petit fichier texte placé sur votre ordinateur par ce site Web
            lorsque vous visitez certaines parties du site Web et/ou lorsque
            vous utilisez certaines fonctionnalités du site Web. Les détails des
            cookies utilisés par ce site Web sont indiqués dans la clause
            ci-dessous (Cookies) ;
          </div>
        </div>
        <div className="flex border-b border-opacity-20 dark:border-gray-300 dark:bg-gray-50">
          <div className="w-32 px-2 py-3 sm:p-3">
            <p className="text-lg">Lois sur la protection des données</p>
          </div>
          <div className="flex-1 block px-2 py-3  sm:p-3 sm:w-auto text-sm">
            toute loi applicable relative au traitement des données
            personnelles, y compris, mais sans s'y limiter, le RGPD, et toutes
            les lois, réglementations et législations dérivées nationales
            d'application et complémentaires ;
          </div>
        </div>
        <div className="flex border-b border-opacity-20 dark:border-gray-300 dark:bg-gray-50">
          <div className="w-32 px-2 py-3 sm:p-3">
            <p className="text-lg">Le RGPD</p>
          </div>
          <div className="flex-1 block px-2 py-3 truncate sm:p-3 sm:w-auto text-sm">
            le règlement général sur la protection des données du Royaume-Uni;
          </div>
        </div>
        <div className="flex border-b border-opacity-20 dark:border-gray-300 dark:bg-gray-50">
          <div className="w-32 px-2 py-3 sm:p-3">
            <p className="text-lg">Vivalimda Ltd., nous ou notre</p>
          </div>
          <div className="flex-1 block px-2 py-3 truncate sm:p-3 sm:w-auto text-sm">
            Vivalimda Ltd., une société immatriculée en Angleterre et au Pays
            14185160 de Galles dont le siège social est situé au 150 Midsummer
            Boulevard, Milton Keynes, MK9 1FD ;
          </div>
        </div>
        <div className="flex border-b border-opacity-20 dark:border-gray-300 dark:bg-gray-50">
          <div className="w-32 px-2 py-3 sm:p-3">
            <p className="text-lg">
              Loi sur les cookies au Royaume-Uni et dans l'UE
            </p>
          </div>
          <div className="flex-1 block px-2 py-3 truncate sm:p-3 sm:w-auto text-sm">
            le règlement de 2003 sur la protection de la vie privée et les
            communications électroniques (directive CE), tel que modifié par le
            règlement de 2011 sur la protection de la vie privée et les
            communications électroniques (directive CE) (amendement) et le
            règlement de 2018 sur la protection de la vie privée et les
            communications électroniques (directive CE) (amendement);
          </div>
        </div>
        <div className="flex border-b border-opacity-20 dark:border-gray-300 dark:bg-gray-50">
          <div className="w-32 px-2 py-3 sm:p-3">
            <p className="text-lg">Utilisateur ou vous</p>
          </div>
          <div className="flex-1 block px-2 py-3 truncate sm:p-3 sm:w-auto text-sm">
            tout tiers qui accède au site Web et qui n'est pas (i) employé par
            Vivalimda Ltd. et agissant dans le cadre de son emploi ou (ii)
            engagé en tant que consultant ou fournissant autrement des services
            à Vivalimda Ltd. et accédant au site Web dans le cadre de la
            fourniture de ces services ; et
          </div>
        </div>
        <div className="flex border-b border-opacity-20 dark:border-gray-300 dark:bg-gray-50">
          <div className="w-32 px-2 py-3 sm:p-3">
            <p className="text-lg">Site internet</p>
          </div>
          <div className="flex-1 block px-2 py-3 truncate sm:p-3 sm:w-auto text-sm">
            Le site Web que vous utilisez actuellement, www.motickets.co.uk et
            tous les sous-domaines de ce site, sauf exclusion expresse par leurs
            propres conditions générales.{" "}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TableForPolicy;
